export default (obj, start, end, duration, format, currency, currencySuffix) => {
  let startTimestamp = null;

  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);

    let html = `${Math.floor(progress * (end - start) + start)}%`;

    if (format === 'money') {
      html = Shopify.formatMoney(
        Math.floor(progress * ((end * 100) - start) + start),
        theme.moneyFormat,
      ).toString().replace(currency, currencySuffix);
    }

    obj.textContent = html;

    if (progress < 1) window.requestAnimationFrame(step);
  };

  window.requestAnimationFrame(step);
};
